// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  hash: __t.string().primaryKey(),
  sizeBytes: __t.u32().name("size_bytes"),
  referenceCount: __t.u32().name("reference_count"),
  firstUploadedAt: __t.timestamp().name("first_uploaded_at"),
  uploadedBy: __t.identity().name("uploaded_by"),
});
